export default "__VITE_ASSET__IWr$ShQT__"